import { render, staticRenderFns } from "./PopupQuestionComponent.vue?vue&type=template&id=49807972"
import script from "./PopupQuestionComponent.vue?vue&type=script&lang=js"
export * from "./PopupQuestionComponent.vue?vue&type=script&lang=js"
import style0 from "./PopupQuestionComponent.vue?vue&type=style&index=0&id=49807972&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports